export const MAX_VISIBLE = 2
